import React, {useEffect, useRef} from 'react';
import request, {METHODS} from '@/api'
import {useEffect, useState} from 'react'
import {
  SDrawerOrModal, SFuncModal, SGeneralForms, SMessage, STitle,
} from 'shj-components'
import {
  addNewTrackPlan,
  getBizOpTypeEnum,
  getContractAreaRangeEnum,
  getCustomerCareerEnum,
  getHouseDecorateStyleEnum,
  getHouseKindEnum,
  getHouseNatureEnum,
  getHouseStatusEnum,
  getHouseTypeEnum,
  getPermanentResidentsEnum,
  getProductionTypeEnum,
  getResidencePurposeEnum,
  getSignBillIntentEnum,
  getAddRecordTypeEnum,
  getCustomerSource,
  getBudGetEnums,
  updateTrackPlan
} from "@/services/customerServices.ts";
import {fetchAllList} from '@/services';
import {getEnums, getRealEstateList} from '@/services/homeService';
import {Form, Input, Select, DatePicker, TreeSelect, message, InputNumber, Radio, Tooltip} from 'antd';
import dayjs from 'dayjs';
import styles from './index.module.less';
import {authDict} from 'shj-utils';
import useValidate from "@/hooks/useValidate.ts";
import {addClue, getEditBuildingPermission, updateClue} from "@/services/saleOpServices.ts";
import {getBizTypes, viewPhoneByClueId, viewPhoneBySource} from "@/services/callCenter";
import {get, isEmpty} from "lodash-es";
import {getAuth} from "@/utils/auth.ts";
import {getChannelBrandAgent} from "@/services/getUsers.ts";
import {getParentId} from "@/utils/common.ts";
import {dateFormat} from "@/utils/date.ts";
import {CheckThePhoneFormItem, CheckThePhoneInputForm} from "@/components/CheckThePhone";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {getBusinessDictList} from "@/services/product.ts";
import {getTags} from "@/services/user.ts";

export default function AddNewPlanModal({
                                          basicInfo = {},
                                          isEdit = false,
                                          open = false,
                                          onClose = () => {
                                          },
                                          reload = () => {
                                          },
                                          editReload = () => {
                                          },
                                          viewPhoneKey = '',
                                          editPhoneKey = '',
                                          editCustomerChannelKey = '',
                                        }) {
  const [form] = Form.useForm();
  const [dictionaryData, setDictionaryData] = useState({});
  const [customerOrigin, setCustomerOrigin] = useState<Array<any>>([]);
  const [orgOptions, setOrgOptions] = useState<Array<any>>([]);
  const [buildOptions, setBuildOptions] = useState<Array<any>>([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isEditBuild, setIsEditBuild] = useState(false);
  const [isErrorPhone, setIsErrorPhone] = useState(false);
  const [phone, setPhone] = useState('');
  const [fullPhone, setFullPhone] = useState('');
  const [editId, setEditId] = useState('');
  const [validateHelper] = useValidate()
  const houseStatus = Form.useWatch(['houseInfo', 'houseStatus'], form)

  const auth = getAuth()
  let companyId = '';
  try {
    const user = JSON.parse((localStorage.getItem('user') || '{}'));
    companyId = user?.companyId;
  } catch (err) {
    console.log(err);
  }

  useEffect(() => {
    if (open) fetchDictionaryData();
    if (open) {
      console.log('新增/编辑线索--->', isEdit)
    }
    return() => {
      form.resetFields()
    }
  }, [open]);

  useEffect(() => {
    if (isEdit) {
      if (!isEmpty(basicInfo)) {
        getEditBuildState(basicInfo.id)
        getInfo()
      }
    }
  }, [isEdit, basicInfo])

  useEffect(() => {
    open && !isEdit && onCompanyChange(companyId)
  }, [companyId, isEdit, open]);

  useEffect(() => {
    form.setFieldValue(['customerInfo', 'phone'], fullPhone || phone)
  }, [fullPhone]);

  const safeSplit = (value, delimiter = ',')=>{
    return typeof value === 'string'&&value ? value.split(delimiter) : [];
  }
  const safeJoin = (arr?: string[] | null, delimiter = ','): string => {
    return arr?.length ? arr.join(delimiter) : '';
  };
  const getInfo = async () => {
    setEditId((basicInfo as any)?.id);
    const {customerInfo, dtlInfo, houseInfo} = basicInfo
    if(houseInfo.orgId) {
      await onCompanyChange(houseInfo.orgId)
    }
    const phone = customerInfo.phone;
    setPhone(phone)
    let idPath;
    await getCustomerSource({state: isEdit ? undefined : 'CHECKED'}).then(res => {
      if (res instanceof Array) {
        setCustomerOrigin(res);
        if (res?.length > 0 && houseInfo.channelId) {
          idPath = getParentId(res, houseInfo.channelId)?.reverse();
        }
      }
    })
    console.log('getInfo---->channelId', idPath )
    const info = {
      ...basicInfo,
      customerInfo: {
        ...customerInfo,
        customerId: customerInfo.id || basicInfo?.customerId,
        birthday: customerInfo.birthday ? dayjs(customerInfo.birthday) : null,
        phone,
      },
      houseInfo: {
        ...houseInfo,
        channelId: idPath,
        handoverDate: houseInfo.handoverDate ? dayjs(houseInfo.handoverDate) : null,
      },
      dtlInfo: {
        ...dtlInfo,
        expectRenovationDate: dtlInfo.expectRenovationDate ? dayjs(dtlInfo.expectRenovationDate) : null,
        estimatedRenovationTime: dtlInfo.estimatedRenovationTime ? dayjs(dtlInfo.estimatedRenovationTime) : null,
        lookingForwardToStayingTime: dtlInfo.lookingForwardToStayingTime ? dayjs(dtlInfo.lookingForwardToStayingTime) : null,
        painPoint: safeSplit(dtlInfo?.painPoint, '-'),
        itchPoint: safeSplit(dtlInfo?.itchPoint, '-'),
        breakPoint: safeSplit(dtlInfo?.breakPoint, '-'),
        blockPoint: safeSplit(dtlInfo?.blockPoint, '-'),
        childAge: safeSplit(dtlInfo?.childAge),
        childGender: safeSplit(dtlInfo?.childGender),
        pets: safeSplit(dtlInfo?.pets),
        competitorCompany: safeSplit(dtlInfo?.competitorCompany),
        renovationDemand: safeSplit(dtlInfo?.renovationDemand),
      },
    }
    form.setFieldsValue(info);
  }

  const getEditBuildState = (clueId) => {
    getEditBuildingPermission(clueId).then(res => {
      setIsEditBuild(res)
    })
  }

  const formatOriginData = (data: any) => {
    if (data.children) {
      data.disabled = true;
      data.children.forEach(child => formatOriginData(child));
    }
  }
  const fetchDictionaryData = async () => {
    setButtonLoading(true)
    try {
      const orgList = await fetchAllList('company');
      if (orgList instanceof Array) {
        const options = orgList?.map(org => ({
          value: org.id,
          label: org.name,
        }));
        setOrgOptions(options);
      }
      isEdit && getCustomerSource({state: isEdit ? undefined : 'CHECKED'}).then(res => {
        if (res instanceof Array) {
          setCustomerOrigin(res);
        }
      })

      const resList: any = await Promise.allSettled([
        getBizTypes(),
        getContractAreaRangeEnum(),
        getCustomerCareerEnum(),
        getHouseDecorateStyleEnum(),
        getHouseKindEnum(),
        getHouseNatureEnum(),
        getHouseStatusEnum(),
        getHouseTypeEnum(),
        getPermanentResidentsEnum(),
        getProductionTypeEnum(),
        getResidencePurposeEnum(),
        getSignBillIntentEnum(),
        getAddRecordTypeEnum(),
        getBudGetEnums(),
        getChannelBrandAgent(),
        getEnums(
            "dispatcher",
            "com.shj.saas.plus.clue.enums.ArmyAffiliation",
        ),
        // 痛点 com.shj.saas.plus.crm.enums.clue.PainPoint
        // 痒点 com.shj.saas.plus.crm.enums.clue.ItchPoint
        // 爆破点 com.shj.saas.plus.crm.enums.clue.BreakPoint
        // 障碍点 com.shj.saas.plus.crm.enums.clue.BlockPoint
        getEnums("plus-crm","com.shj.saas.plus.crm.enums.clue.PainPoint" ),
        getEnums("plus-crm","com.shj.saas.plus.crm.enums.clue.ItchPoint" ),
        getEnums("plus-crm","com.shj.saas.plus.crm.enums.clue.BreakPoint"),
        getEnums("plus-crm","com.shj.saas.plus.crm.enums.clue.BlockPoint"),
        getBusinessDictList({data: {priKey: 'age_range'}}),
        getTags({tagCategoryCode: 'TC03'}),
        getBusinessDictList({data: {priKey: 'pets'}}),
        getBusinessDictList({data: {priKey: 'house_renovation_demand'}}),
      ]);
      const signIntentionCode = resList?.[11]?.value instanceof Array ? resList?.[11]?.value : []
      // signIntentionCode.forEach(item => {
      //   switch (item.key){
      //   case 'signBillIntentA':
      //     item.description = `A类：线索有效，且是企微好友，且有需求属性，且有装修预算，且有装修风格，且房屋状态为现房，短时间内能邀约到店`;
      //     break;
      //     case 'signBillIntentB':
      //     item.description = `B类：线索有效，且是企微好友，且有需求属性，需要花稍微多一点的时间才能邀约到店`;
      //     break;
      //     case 'signBillIntentC':
      //     item.description = `C类：线索有效，需要花大量时间才可能邀约到店`;
      //     break;
      //   }
      // })
      const map = {
        bizType: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
        constructArea: resList?.[1]?.value instanceof Array ? resList?.[1]?.value : [],
        career: resList?.[2]?.value instanceof Array ? resList?.[2]?.value : [],
        designStyleCode: resList?.[3]?.value instanceof Array ? resList?.[3]?.value : [],
        houseKindCode: resList?.[4]?.value instanceof Array ? resList?.[4]?.value : [],
        houseNatureCode: resList?.[5]?.value instanceof Array ? resList?.[5]?.value : [],
        houseStatus: resList?.[6]?.value instanceof Array ? resList?.[6]?.value : [],
        layout: resList?.[7]?.value instanceof Array ? resList?.[7]?.value : [],
        permanentResidents: resList?.[8]?.value instanceof Array ? resList?.[8]?.value : [],
        intentionProductCode: resList?.[9]?.value instanceof Array ? resList?.[9]?.value : [],
        livePurpose: resList?.[10]?.value instanceof Array ? resList?.[10]?.value : [],
        signIntentionCode,
        addRecordType: resList?.[12]?.value instanceof Array ? resList?.[12]?.value : [],
        budget: resList?.[13]?.value instanceof Array ? resList?.[13]?.value : [],
        channelBrand: resList?.[14]?.value instanceof Array ? resList?.[14]?.value : [],
        armyAffiliation: resList?.[15]?.value instanceof Array ? resList?.[15]?.value : [],
        painPoint: resList?.[16]?.value instanceof Array ? resList?.[16]?.value : [],
        itchPoint: resList?.[17]?.value instanceof Array ? resList?.[17]?.value : [],
        breakPoint: resList?.[18]?.value instanceof Array ? resList?.[18]?.value : [],
        blockPoint: resList?.[19]?.value instanceof Array ? resList?.[19]?.value : [],
        ageRange: resList?.[20]?.value instanceof Array ? getDictList(resList?.[20]?.value) : [],
        competitorCompanies: resList?.[21]?.value instanceof Array ? resList?.[21]?.value : [],
        pets: resList?.[22]?.value instanceof Array ? getDictList(resList?.[22]?.value) : [],
        houseDemand: resList?.[23]?.value instanceof Array ? getDictList(resList?.[23]?.value) : [],
      }
      setDictionaryData(map);
    } catch (err) {
      console.log(err)
    } finally {
      setButtonLoading(false)
    }
  }

  const getDictList = (list) => {
    const data =  get(list, '[0].children[0].children[0].children', [])
    return data.map(item => ({...item, ...item.object}))
  }

  const onCompanyChange = async (value: any) => {
    isEdit ? form.resetFields([['houseInfo', 'buildingId']]) : form.resetFields([['houseInfo', 'channelId'], ['houseInfo', 'buildingId']])
    if (value) {
      setButtonLoading(true)
      try {
        await getRealEstateList({orgId: value}).then(res => {
          setBuildOptions(res)
        })
        if(!isEdit) {
          console.log('isEdit--->fetch', isEdit)
          await getCustomerSource({state: isEdit ? undefined : 'CHECKED', orgId: value}).then(res => {
            if (res instanceof Array) {
              setCustomerOrigin(res);
            }
          })
        }
      } finally {
        setButtonLoading(false)
      }

    } else {
      setCustomerOrigin([]);
      setBuildOptions([])
    }
  }

  const disabledDate = (current) => {
    const ninetyDaysLater = dayjs().add(3, 'month').endOf('day');
    switch (houseStatus){
        // 期房(三月后交房)
      case 'FUTURE_HOUSE':
        return current && current < ninetyDaysLater;
        // 现房(已交房)
      case 'EXISTING_HOUSE':
        return current && current > dayjs().endOf('day');
        // 准现房(三月内交房)
      case 'QUASI_EXISTING_HOUSE':
        return current && (current < dayjs().endOf('day') || current > ninetyDaysLater);
    }
  };

  const getDefaultPickerValue = () => {
    const ninetyDaysLater = dayjs().add(3, 'month').endOf('day');
    switch (houseStatus){
        // 期房(三月后交房)
      case 'FUTURE_HOUSE':
        return ninetyDaysLater.add(1, 'day');
        // 准现房(三月内交房)
      case 'QUASI_EXISTING_HOUSE':
        return dayjs().add(1, 'day').endOf('day');
      default:
        return dayjs();
    }
  }

  const dateState = (targetTimestamp) => {
    const current = dayjs(targetTimestamp)
    const threeMonthsLater = dayjs().add(3, 'month'); // 三个月后
    if (current.isAfter(threeMonthsLater)) {
      return 'FUTURE_HOUSE'; // 期房（三个月后交房）
    } else if (current.isBefore(dayjs())) {
      return 'EXISTING_HOUSE'; // 现房（已交房）
    } else {
      return 'QUASI_EXISTING_HOUSE'; // 准现房（三个月内交房）
    }
  };

  const onChangeBuilding = (option: any) => {
    form.setFieldValue( ['houseInfo', 'handoverDate'], option?.handoverDate ? dayjs(option?.handoverDate) : '')
    form.setFieldValue( ['houseInfo', 'houseStatus'], option?.handoverDate ? dateState(option?.handoverDate) : null)
  }

  const onSubmit = () => {
    if (isErrorPhone) return message.error('号码格式不正确, 请填写完整的电话号码')
    form.validateFields().then(async (values: any) => {
      setButtonLoading(true);
      const apiFn = isEdit ? updateClue : addClue;
      const _values = {
        ...values,
        id: values.id || basicInfo.id,
        dtlInfo: {
          ...values.dtlInfo,
          painPoint: safeJoin(values.dtlInfo?.painPoint, '-'),
          itchPoint: safeJoin(values.dtlInfo?.itchPoint, '-'),
          breakPoint: safeJoin(values.dtlInfo?.breakPoint, '-'),
          blockPoint: safeJoin(values.dtlInfo?.blockPoint, '-'),
          childAge: safeJoin(values.dtlInfo?.childAge),
          competitorCompany: safeJoin(values.dtlInfo?.competitorCompany),
          childGender: safeJoin(values.dtlInfo?.childGender),
          pets: safeJoin(values.dtlInfo?.pets),
          renovationDemand: safeJoin(values.dtlInfo?.renovationDemand),
          expectRenovationDate: dateFormat(values.dtlInfo?.expectRenovationDate,'YYYY-MM-DD HH:mm:ss'),
          estimatedRenovationTime: dateFormat(values.dtlInfo?.estimatedRenovationTime,'YYYY-MM-DD HH:mm:ss'),
          lookingForwardToStayingTime: dateFormat(values.dtlInfo?.lookingForwardToStayingTime,'YYYY-MM-DD HH:mm:ss'),
        },
        houseInfo: {
          ...values.houseInfo,
          handoverDate: dateFormat(values.houseInfo?.handoverDate,'YYYY-MM-DD HH:mm:ss'),
          channelId: values.houseInfo?.channelId[values.houseInfo?.channelId.length - 1]
        }
      }
      apiFn(_values).then(res => {
        message.success(res.message || '操作成功');
        onClose();
        reload();
      }).catch(err => {
        message.error(err.message)
      }).finally(() => {
        setButtonLoading(false);
      })
    }).catch((err) => {
      console.log(err)
      const errorStr = err.errorFields?.[0]?.errors?.[0]
      message.error(errorStr)
    })
  }

  return (
      <div className={styles.addNewPlanModal}>
        <SDrawerOrModal
            mode="drawer"
            open={open}
            loading={buttonLoading}
            onCancel={() => onClose()}
            onOk={onSubmit}
            width="900"
            style={{minWidth: 500}}
            title={isEdit ? "编辑基本信息" : "新增线索"}
        >
          <SGeneralForms
              layout={'vertical'}
              titleMode={'edit'}
              formConfig={{form}}
              initialValues={{houseInfo: {orgId: companyId}}}
              configs={[{
                title: '客户信息',
                formItem: [
                  {label: 'id', name: 'id', hidden: true},
                  {label: 'customerId', name: ['customerInfo', 'customerId'], hidden: true},
                  {
                    spanCol: 12,
                    label: '客户姓名',
                    name: ['customerInfo', 'name'],
                    required: true,
                    rules: [{required: true, message: '请填写客户姓名'}],
                    comConfig: {
                      maxLength: 50,
                      showCount: true,
                      placeholder: '请输入客户名称',
                      onBlur: e => {
                        const value = e.target.value
                        // 去除所有空格
                        if (value) {
                          const newValue = value.replace(/\s/g, '')
                          form.setFieldValue(['customerInfo', 'name'], newValue)
                        }
                      },
                    },
                  },
                  {
                    spanCol: 12,
                    label: '客户号码',
                    name: ['customerInfo', 'phone'],
                    required: true,
                    rules: [
                      {required: true, message: '请填写客户号码'},
                      {
                      // 编辑时 判断星号
                      pattern : isEdit ? /^([1-9]{1}\d{2}(\d{4}|\*{4})\d{4})$/ : /^[1-9]\d{10}$/,
                      message: '号码格式不正确',
                    }],
                    comConfig: {
                      maxLength: 11,
                      disabled: isEdit && !auth?.[editPhoneKey],
                      addonAfter: isEdit ? <CheckThePhoneInputForm id={basicInfo.id} auth={viewPhoneKey} fn={(phone) => setFullPhone(phone)}/> : null,
                      onBlur: (e) => {
                        if(isEdit){
                          const newPhone = e.target.value;
                          if((newPhone !== basicInfo?.customerInfo?.phone) && /\*{4}/.test(newPhone)) {
                            setIsErrorPhone(true)
                            SMessage.confirm({
                              title: '号码格式不正确, 请填写完整的电话号码',
                              content: null,
                            })
                          } else {
                            setIsErrorPhone(false)
                          }
                        }
                      }
                    },
                    // customRender: (form, name) => {
                    //   return <Form.Item label={'客户号码'} name={name}>
                    //     <Input addonAfter={} placehol/>
                    //   </Form.Item>
                    // }
                  },
                  {
                    spanCol: 12,
                    label: '性别',
                    name: ['customerInfo', 'gender'],
                    children: <Radio.Group options={[{value: '男', label: '男'}, {value: '女', label: '女'}]}/>
                  },
                  {
                    spanCol: 12,
                    label: '年龄',
                    name: ['customerInfo', 'age'],
                    type: 'inputNumber',
                    comConfig: {
                      precision: 0,
                      min: 0,
                      max: 200
                    }
                  },
                  {
                    spanCol: 12,
                    label: '生日',
                    name: ['customerInfo', 'birthday'],
                    type: 'date',
                    comConfig: {
                    }
                  },
                  {
                    spanCol: 12,
                    label: '职业',
                    name: ['customerInfo', 'career'],
                    children: <Select placeholder={'请选择职业'} fieldNames={{label: 'description', value: 'key'}}
                                      options={dictionaryData['career']} allowClear showSearch optionFilterProp={'description'}/>,
                  },
                  {
                    spanCol: 12,
                    label: '邮箱',
                    name: ['customerInfo', 'email'],
                  },
                ]
              },
                {
                  title: '房屋信息',
                  formItem: [
                    {
                      spanCol: 12,
                      label: '门店',
                      name: ['houseInfo', 'orgId'],
                      required: true,
                      rules: [{required: true, message: '请选择门店'}],
                      children: <Select placeholder={'请选择门店'} showSearch allowClear optionFilterProp="label"
                                        options={orgOptions} onChange={(e) => onCompanyChange(e)}/>
                    },
                    {
                      spanCol: 12,
                      label: '客户来源',
                      name: ['houseInfo', 'channelId'],
                      type: 'cascader',
                      required: true,
                      rules: [{required: true, message: '请选择客户来源'}],
                      comConfig: {
                        options: customerOrigin,
                        disabled: isEdit && !auth?.[editCustomerChannelKey],
                        expandTrigger: 'hover',
                        showSearch: true,
                        notFoundContent: '请选择公司或无匹配数据',
                      }
                    },
                    {
                      spanCol: 12,
                      label: '品牌',
                      name: ['houseInfo', 'channelBrandId'],
                      required: true,
                      rules: [{required: true, message: '请选择品牌'}],
                      children: <Select placeholder={'请选择品牌'}
                                        fieldNames={{label: 'brandName', value: 'id'}}
                                        showSearch allowClear optionFilterProp="brandName"
                                        options={dictionaryData['channelBrand']}/>
                    },
                    {
                      spanCol: 12,
                      label: '总分归属',
                      name: ['houseInfo', 'armyAffiliation'],
                      required: true,
                      rules: [{required: true, message: '请选择总分归属'}],
                      children: <Select placeholder={'请选择总分归属'} disabled={isEdit}
                                        fieldNames={{label: 'description', value: 'key'}}
                                        showSearch allowClear optionFilterProp="description"
                                        options={dictionaryData['armyAffiliation']}/>
                    },
                    {
                      spanCol: 12,
                      label: '楼盘',
                      name: ['houseInfo', 'buildingId'],
                      required: true,
                      rules: [{required: true, message: '请选择楼盘'}],
                      children: <Select placeholder={'请选择楼盘'} showSearch optionFilterProp="name"
                                        fieldNames={{label: 'name', value: 'id'}}
                                        disabled={ isEdit && !isEditBuild }
                                        onChange={(e, option) => onChangeBuilding(option)}
                                        allowClear
                                        notFoundContent={'请选择公司或无匹配数据'}
                                        options={buildOptions}/>
                    },
                    {
                      spanCol: 12,
                      label: '门牌号',
                      name: ['houseInfo', 'doorNo'],
                      comConfig: {
                        maxLength: 20,
                      }
                    },
                    {
                      spanCol: 12,
                      label: '房屋属性',
                      name: ['houseInfo', 'houseNatureCode'],
                      children: <Select placeholder={'请选择房屋属性'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['houseNatureCode']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '房屋状态',
                      name: ['houseInfo', 'houseStatus'],
                      children: <Select placeholder={'请选择房屋状态'} fieldNames={{label: 'description', value: 'key'}}
                                        disabled={!isEdit || (isEdit && !auth['salesDeliveryTimeField'])}
                                        onChange={(v) => {
                                          form.setFieldValue(['houseInfo', 'handoverDate'], v === 'EXISTING_HOUSE' ? dayjs() : null);
                                        }}
                                        options={dictionaryData['houseStatus']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '房屋类型',
                      name: ['houseInfo', 'houseKindCode'],
                      children: <Select placeholder={'请选择房屋类型'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['houseKindCode']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '户型',
                      name: ['houseInfo', 'layout'],
                      children: <Select placeholder={'请选择户型'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['layout']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '建筑面积',
                      name: ['houseInfo', 'constructArea'],
                      type: 'inputNumber',
                      comConfig: {
                        precision: 2,
                        min: 0.01,
                        max: 999999999.99,
                      }
                    },
                    {
                      spanCol: 12,
                      label: '套内面积',
                      name: ['houseInfo', 'innerArea'],
                      type: 'inputNumber',
                      comConfig: {
                        precision: 2,
                        min: 0.01,
                        max: 999999999.99,
                      }
                    },
                    {
                      spanCol: 12,
                      label: '层高',
                      name: ['houseInfo', 'houseHight'],
                      type: 'inputNumber',
                      comConfig: {
                        precision: 2,
                        min: 0.01,
                        max: 999999999.99,
                      }
                    },
                    {
                      spanCol: 12,
                      label: '交房日期',
                      name: ['houseInfo', 'handoverDate'],
                      type: 'date',
                      comConfig: {
                        disabledDate,
                        disabled: !isEdit || (isEdit && !auth['salesDeliveryTimeField']),
                        defaultPickerValue: getDefaultPickerValue(),
                      }
                    },
                  ]
                },
                {
                  title: '家空间需求',
                  formItem: [
                    {
                      spanCol: 12,
                      label: '需求标签',
                      required: true,
                      rules: [{required: true, message: '请选择需求标签'}],
                      name: ['dtlInfo', 'bizTypes'],
                      children: <Select placeholder={'请选择需求标签'}
                                        mode={'multiple'}
                                        allowClear showSearch
                                        optionFilterProp={'description'}
                                        fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['bizType']}/>
                    },
                    {
                      spanCol: 12,
                      label: '装修预算',
                      name: ['dtlInfo', 'budget'],
                      children:  <Select placeholder={'请选择装修预算'} fieldNames={{label: 'description', value: 'key'}}
                                         options={dictionaryData['budget']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '装修风格',
                      name: ['dtlInfo', 'designStyleCode'],
                      children:  <Select placeholder={'请选择装修风格'} fieldNames={{label: 'description', value: 'key'}}
                                         options={dictionaryData['designStyleCode']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '居住目的',
                      name: ['dtlInfo', 'livePurpose'],
                      children:  <Select placeholder={'请选择居住目的'} fieldNames={{label: 'description', value: 'key'}}
                                         options={dictionaryData['livePurpose']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '常住人口',
                      name: ['dtlInfo', 'permanentResidents'],
                      children:  <Select placeholder={'请选择常住人口'} fieldNames={{label: 'description', value: 'key'}}
                                         options={dictionaryData['permanentResidents']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '孩子性别',
                      name: ['dtlInfo', 'childGender'],
                      type: 'select',
                      comConfig: {
                        mode: 'multiple',
                        options: [
                          {label: '男', value: '男'},
                          {label: '女', value: '女'}
                        ],
                      }
                    },
                    {
                      spanCol: 12,
                      label: '孩子年龄',
                      name: ['dtlInfo', 'childAge'],
                      type: 'select',
                      comConfig: {
                        mode: 'multiple',
                        options: dictionaryData['ageRange'],
                        fieldNames: {label: 'label', value: 'priKey'}
                      }
                    },
                    {
                      spanCol: 12,
                      label: '宠物',
                      name: ['dtlInfo', 'pets'],
                      type: 'select',
                      comConfig: {
                        mode: 'multiple',
                        options: dictionaryData['pets'],
                        fieldNames: {label: 'label', value: 'priKey'}
                      }
                    },
                    {
                      spanCol: 12,
                      label: '宠物备注',
                      name: ['dtlInfo', 'petsOther'],
                      isDeps: true,
                      deps: (form) => form.getFieldValue(['dtlInfo', 'pets'])?.includes('pets_other'),
                      comConfig: {
                        maxLength: 200,
                        showCount: true,
                      }
                    },
                    {
                      spanCol: 12,
                      label: '竞品公司',
                      name: ['dtlInfo', 'competitorCompany'],
                      type: 'select',
                      comConfig: {
                        mode: 'multiple',
                        options: dictionaryData['competitorCompanies'],
                        fieldNames: {label: 'name', value: 'code'}
                      }
                    },
                    {
                      spanCol: 12,
                      label: '户型改造需求',
                      name: ['dtlInfo', 'renovationDemand'],
                      type: 'select',
                      comConfig: {
                        mode: 'multiple',
                        options: dictionaryData['houseDemand'],
                        fieldNames: {label: 'label', value: 'priKey'}
                      }
                    },
                    {
                      spanCol: 12,
                      label: '户型改造需求备注',
                      name: ['dtlInfo', 'renovationDemandOther'],
                      isDeps: true,
                      deps: (form) => form.getFieldValue(['dtlInfo', 'renovationDemand'])?.includes("house_renovation_demand_other"),
                      comConfig: {
                        maxLength: 200,
                        showCount: true,
                      }
                    },
                    {
                      spanCol: 12,
                      label: <>客户意向 <Tooltip title={` A类:线索有效，且是企微好友，且有需求属性，且有装修预算，且有装修风格，且房屋状态为现房，短时间内能邀约到店
                                 B类:线索有效，且是企微好友，且有需求属性，需要花稍微多一点的时间才能邀约到店
                                 C类:线索有效，需要花大量时间才可能邀约到店`} overlayStyle={{ whiteSpace: 'pre-line' }}><QuestionCircleOutlined style={{marginLeft: 5, color: 'rgba(0, 0, 0, 0.45)'}}/></Tooltip></>,
                      name: ['dtlInfo', 'signIntentionCode'],
                      children: <Select placeholder={'请选择客户意向'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['signIntentionCode']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '产品意向',
                      name: ['dtlInfo', 'intentionProductCode'],
                      children:  <Select placeholder={'请选择产品意向'} fieldNames={{label: 'description', value: 'key'}}
                                         options={dictionaryData['intentionProductCode']} allowClear showSearch optionFilterProp={'description'}/>
                    },

                    {
                      spanCol: 12,
                      label: '预计进场装修时间',
                      name: ['dtlInfo', 'expectRenovationDate'],
                      type: 'date',
                      comConfig: {
                      }
                    },
                    {
                      spanCol: 12,
                      label: '预计定装修时间',
                      name: ['dtlInfo', 'estimatedRenovationTime'],
                      type: 'date',
                      comConfig: {
                      }
                    },
                    {
                      spanCol: 12,
                      label: '期待入住时间',
                      name: ['dtlInfo', 'lookingForwardToStayingTime'],
                      type: 'date',
                      comConfig: {
                      }
                    },
                    {
                      spanCol: 12,
                      label: '痛点',
                      name: ['dtlInfo', 'painPoint'],
                      children: <Select mode={"multiple"} placeholder={'请选择痛点'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['painPoint']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '痛点备注',
                      name: ['dtlInfo', 'painPointRemark'],
                      isDeps: true,
                      deps: (form) => form.getFieldValue(['dtlInfo', 'painPoint'])?.includes('PainPointOther'),
                      comConfig: {
                        maxLength: 200,
                        showCount: true
                      }
                    },
                    {
                      spanCol: 12,
                      label: '痒点',
                      name: ['dtlInfo', 'itchPoint'],
                      children: <Select mode={"multiple"} placeholder={'请选择痒点'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['itchPoint']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '痒点备注',
                      name: ['dtlInfo', 'itchPointRemark'],
                      isDeps: true,
                      deps: (form) => form.getFieldValue(['dtlInfo', 'itchPoint'])?.includes('ItchyOther'),
                      comConfig: {
                        maxLength: 200,
                        showCount: true
                      }
                    },
                    {
                      spanCol: 12,
                      label: '障碍点',
                      name: ['dtlInfo', 'blockPoint'],
                      children: <Select mode={"multiple"} placeholder={'请选择障碍点'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['blockPoint']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                      {
                      spanCol: 12,
                      label: '障碍点备注',
                      name: ['dtlInfo', 'blockPointRemark'],
                      isDeps: true,
                      deps: (form) => form.getFieldValue(['dtlInfo', 'blockPoint'])?.includes('ObstaclePointOther'),
                      comConfig: {
                        maxLength: 200,
                        showCount: true
                      }
                    },
                    {
                      spanCol: 12,
                      label: '爆破点',
                      name: ['dtlInfo', 'breakPoint'],
                      children: <Select mode={"multiple"} placeholder={'请选择爆破点'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['breakPoint']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                      {
                      spanCol: 12,
                      label: '爆破点备注',
                      name: ['dtlInfo', 'breakPointRemark'],
                      isDeps: true,
                      deps: (form) => form.getFieldValue(['dtlInfo', 'breakPoint'])?.includes('BlastingPointOther'),
                      comConfig: {
                        maxLength: 200,
                        showCount: true
                      }
                    },
                    {
                      spanCol: 24,
                      label: '备注',
                      name: ['dtlInfo', 'remark'],
                      type: 'textarea',
                      comConfig: {
                       maxLength: 700,
                        showCount: true
                      }
                    },
                  ]
                }
              ]}/>
        </SDrawerOrModal>
      </div>
  )
}
